type InfoSectionProps = {
  title: string;
  items: string[];
  className?: string;
};

export default function InfoSection({
  title,
  items,
  className = "",
}: InfoSectionProps) {
  if (items.length === 0) return null;

  return (
    <div className={`mt-12 ${className}`}>
      <h2 className="text-lg md:text-xl font-normal text-ui-card">{title}</h2>
      <div className="mt-4 md:mt-6 h-px w-full bg-ui-card/10" />
      <ul className="mt-4 md:mt-6 grid grid-cols-1 sm:grid-cols-2 gap-y-2.5 md:gap-y-3 text-sm md:text-base leading-relaxed text-ui-card/70">
        {items.map((item, i) => (
          <li key={i} className="flex items-start">
            <span className="mr-2 text-[#E3F1CE]">•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

